import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileStickyBar } from "@/components/MobileStickyBar";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App font-body">
      <Header />
      <main className="pb-16 xl:pb-0">{children}</main>
      <Footer />
      <MobileStickyBar />
    </div>
  );
};

export default Layout;
